export const USER_NOTE_LEVEL = {
    INFO: "info",
    WARNING: "warning",
    ERROR: "error",
    ARCHIVE_REASON: "archive_reason",
};
